import axios from "axios";
import { deriveErrorMessage } from "libLegacy/internal/deriveErrorMessage";
import { ItemResponse } from "./axios";

export type StatusCredential =
  | "MISSING"
  | "VALIDATED"
  | "PENDING"
  | "UNSUPPORTED"
  | "INVALIDATED";

export type LoginForm = {
  email: string;
  password: string;
  rememberMe?: boolean;
  clinSlug?: string;
};
export type LoginResponse = {
  name: string;
  token: string;
  statusMonitoringPlatform: StatusCredential;
  statusEnergyOperator: StatusCredential;
};

export type PasswordRecoveryResponse = {
  acveID: string;
  createdAt: string;
};

export const authenticate = async (f: LoginForm) => {
  return axios
    .post<LoginResponse>(`${process.env.REACT_APP_AUTH_PATH}/auth/signin`, {
      ...f,
    })
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      console.error(e);
      const error = (e?.response?.data?.error || e)?.message;
      const isWrongUser = error.match(/No user with this e/);
      const isWrongAuth = error.match(/Wrong email\/password/);
      const errorMessage = isWrongUser
        ? "Usuário desativado ou não existente."
        : "";
      const errorMessage2 = isWrongAuth ? "Email ou senha errados." : "";
      const err =
        errorMessage ||
        errorMessage2 ||
        "Falha ao fazer login, Verifique o email e senha digitado.";
      return Promise.reject(err);
    });
};

export const requestPasswordRecover = async (email: string) => {
  return axios
    .post<ItemResponse<PasswordRecoveryResponse>>(
      `${process.env.REACT_APP_AUTH_PATH}/auth/password_recover`,
      { email }
    )
    .then((r) => {
      return r.data.data.item;
    })
    .catch((e) => {
      const err = deriveErrorMessage(e, "rcvr1");
      return Promise.reject(err);
    });
};

export const resetToNewPassword = async (
  resetID: string,
  password: string,
  verification: string
) => {
  return axios
    .post(`${process.env.REACT_APP_AUTH_PATH}/auth/password_reset/${resetID}`, {
      password,
      verification,
    })
    .then((r) => {})
    .catch((e) => {
      const err = deriveErrorMessage(e, "rcvr3");
      return Promise.reject(err);
    });
};
